import { render } from "./PartButton.vue?vue&type=template&id=0e5b668b&scoped=true&ts=true"
import script from "./PartButton.vue?vue&type=script&lang=ts"
export * from "./PartButton.vue?vue&type=script&lang=ts"

import "./PartButton.vue?vue&type=style&index=0&id=0e5b668b&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5b668b"]])

export default __exports__